<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex
        xs12
        sm12
        md3
        xl3>
        <v-btn @click="$router.go(-1)">
          <v-icon
            color="primary"
            class="mr-2">arrow_back</v-icon> Go back to Customer List
        </v-btn>
      </v-flex>
      <v-flex
        xs12
        sm12
        md12
        class="mt-2">
        <formAdminFinancialMonthlyDatatable :type="'customers'"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
  }),
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>
